<template>
  <v-container>
    <v-row>
      <v-col>
        <h3> OM.updateCCInfo get url</h3>
        <iframe allowpaymentrequest="true" referrerpolicy="strict-origin-when-cross" id="embbed" name="embbed" width="100%" height="660" frameborder="0" scrolling="no"></iframe>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OM from "@/api/order-management";
import assetsData from "@/assets/json/assetsTest.json";

const isProd = process.env.VUE_APP_PROD === "true";
export default {
  data() {
    return {
      loadingFinished: false,
      ccList: [],
      url: "https://dspservice.fetnet.net/hlogin/eaiapp/loginForm?ctid=a78a07c3a5444f94b67cd5c181d4d4cb",
      ccUrl: '',
      fetWin: null,
      detectCloseInterval: null
    };
  },
  created() {
    if (isProd) {
      this.$router.push({name: "Index"}).catch(()=>{});
    }
  },
  mounted() {
    this.getCCInfo();
  },
  methods: {
    async getCCInfo() {
      const { data } = await OM.updateCCInfo();

      setTimeout(() => {
        // this.ccUrl = data.url
        document.getElementById('embbed').src = data.url
      }, 2000);
    },
    loaded(e) {
      debugger
    }
  },
};
</script>
